import { ReactNode } from 'react';
import { PageTitle } from '../../../../_admin/layout/core';

type OperationsPageShellProps = {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
};

const OperationsPageShell = ({
  title,
  subtitle,
  action,
  children,
}: OperationsPageShellProps) => (
  <>
    <PageTitle>{title}</PageTitle>
    <div className="card card-flush">
      <div className="card-body">
        {(subtitle || action) && (
          <div className="d-flex align-items-center justify-content-between mb-4">
            {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
            {action}
          </div>
        )}
        {children}
      </div>
    </div>
  </>
);

export default OperationsPageShell;
